import React, { useCallback, useRef, useState } from 'react'

import { useOnClickOutside } from '_hooks'

import './useDialog.scss'

const useDialog = ({ wrapperNode, targetNode, maxSize = {} }) => {
  const dialogRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)

  const dialog = {
    show: () => {
      setIsOpen(true)
    },
    hide: () => {
      setIsOpen(false)
    },
    isOpen,
  }

  useOnClickOutside(dialogRef, () => dialog.hide())

  const wrapper = wrapperNode?.getBoundingClientRect?.() ?? {}
  const target = targetNode?.getBoundingClientRect?.() ?? {}

  const Dialog = useCallback(
    ({ children }) => {
      let pos = {}
      if (target.top + target.height + maxSize.height <= window.innerHeight) {
        // at bottom
        pos.top = Math.floor(target.top - wrapper.top + target.height)
      } else {
        // at top
        pos.bottom = `calc(100% - ${Math.floor(target.top - wrapper.top)}px)`
      }

      if (target.left + maxSize.width <= window.innerWidth) {
        // at left
        pos.left = Math.floor(target.left - wrapper.left)
        pos.margin = 0
      } else {
        // at right
        pos.right = Math.floor(wrapper.right - target.right)
        pos.marginRight = 0
      }

      return (
        <dialog
          ref={dialogRef}
          open={isOpen}
          className="ds-dialog"
          style={{
            maxWidth: maxSize.width,
            maxHeight: maxSize.height,
            display: isOpen ? 'grid' : 'none',
            ...pos,
          }}
        >
          {children}
        </dialog>
      )
    },
    [isOpen]
  )

  return { Dialog, dialog }
}

export default useDialog
